import { Collapse } from "bootstrap"

const desktopMediaQuery = window.matchMedia("(min-width: 992px)")

const closeMobileHeaderMenu = () => {
  if (!desktopMediaQuery.matches) return

  const menu = document.getElementById("frontofficeHeaderMenu")
  if (!menu?.classList.contains("show")) return

  Collapse.getOrCreateInstance(menu, { toggle: false }).hide()
}

document.addEventListener("turbo:load", closeMobileHeaderMenu)
document.addEventListener("turbo:before-cache", () => {
  const menu = document.getElementById("frontofficeHeaderMenu")
  if (!menu) return

  Collapse.getOrCreateInstance(menu, { toggle: false }).hide()
})

desktopMediaQuery.addEventListener("change", closeMobileHeaderMenu)
